module.exports = __webpack_public_path__ + "img/20191125164331587.4b3c284f.jpg";